export default __webpack_public_path__ + "static/media/loudspeaker.93b05b88.png";